import React from 'react';
import moment from 'moment';

import { Typography, Grid, Paper } from '@mui/material';
import ClientLogoContainer from '../ClientLogo';
import { useGotoDetailPageCallback } from '../../states/incidents';

const styles = {
  error: { border: 'solid 1px #f4485e', borderLeft: 'solid 8px #f4485e', padding: '10px', marginBottom: '6px', borderRadius: '5px' },
  success: { border: 'solid 1px #75c31e', borderLeft: 'solid 8px #75c31e', padding: '10px', marginBottom: '6px', borderRadius: '5px' },
  failed: { border: 'solid 1px #4a4a4a', borderLeft: 'solid 8px #4a4a4a', padding: '10px', marginBottom: '6px', borderRadius: '5px' },
  item: {
    fontSize: '15px',
    padding: '2px',
    color: '#5a5a5a',
    textDecoration: 'none',
    cursor: 'pointer',
  },
};

function IncidentListItem({ incident, base }) {
  const openDetail = useGotoDetailPageCallback();
  const style = incident.status === 'CREATED' ? styles.error : incident.status === 'RESOLVED' ? styles.success : styles.failed;
  return (
    <Paper sx={style} p={3} elevation={1} onClick={() => openDetail(incident.id)}>
      <Grid container spacing={0.5} alignItems={'center'}>
        <Grid size={{ xs: 3, md: 2, lg: 1 }}>
          <Typography sx={styles.item}>{incident.object.split('_')[1]}</Typography>
        </Grid>
        <Grid size={{ xs: 2, md: 1 }}>
          <div style={{ marginTop: '-6px', marginBottom: '-6px' }}>
            <ClientLogoContainer size={32} id={incident?.shipment?.client_id} />
          </div>
        </Grid>
        <Grid size={{ xs: 2, md: 2 }}>
          <Typography sx={styles.item}>{moment(incident._created).format('MM/DD hh:mmA')}</Typography>
        </Grid>
        <Grid size={{ xs: 2, md: 1 }}>
          <Typography sx={styles.item}>{incident.delivery_date ? moment(incident.delivery_date).format('MM/DD/YY') : 'N/A'}</Typography>
        </Grid>
        <Grid size={3}>
          <Typography sx={styles.item}>{incident.shipment?.dropoff_address?.street}</Typography>
        </Grid>
        <Grid size={1}>
          <Typography sx={styles.item}>{incident?.shipment?.dropoff_address?.city}</Typography>
        </Grid>
        <Grid size={2}>
          <Typography sx={styles.item}>
            {incident?.shipment?.dropoff_address?.state} {incident?.shipment?.dropoff_address?.zipcode}
          </Typography>
        </Grid>
        <Grid size={1}>
          <Typography sx={styles.item}>{incident?.priority}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default IncidentListItem;
